import { useNavigator } from '@repo/toolkit/use-navigator'
import { Column } from '@repo/ui/data-table'
import { InstructionIcon, PlusIcon } from '@repo/ui/icons'
import Typography from '@repo/ui/typography'
import { useRef } from 'react'

import { API } from '../../api/apis.config'
import DynamicDataTable, { DynamicTableRef } from '../../components/elements/dynamic-table'
import UserNavBar from '../../components/elements/nav-bar'
import { Paths } from '../../lib/constants/path'
import { TripBookingGuideline } from '../../lib/types/models/trip-booking/trip-booking-guildeline'

const TripBookingGuidelineListPage = () => {
  const tableRef = useRef<DynamicTableRef<TripBookingGuideline>>(null)
  const { navigate, navigateWithEvent } = useNavigator()

  const columns: Column<TripBookingGuideline>[] = [
    {
      accessorKey: 'label',
      header: 'Type',
      enableSorting: true
    },
    {
      accessorKey: 'description',
      header: 'Description',
      enableSorting: true,
      // if your table supports column sizing:
      size: 320, // pixels (TanStack Table)
      cell: ({ row }) => (
        <div className="max-w-[20rem]">
          <Typography
            variant="label-medium"
            className="block truncate"
            title={row.original.description ?? ''}
          >
            {row.original.description ?? '—'}
          </Typography>
        </div>
      )
    }
  ]

  return (
    <div>
      <UserNavBar title="Liste des consignes destinées aux compagnies" icon={InstructionIcon} />
      <div className="h-4" />
      <DynamicDataTable<TripBookingGuideline>
        ref={tableRef}
        title="Toutes les consignes"
        columns={columns}
        deleteMessage={{ name: 'la consigne', attributeName: 'label' }}
        selectable
        allowSearchParam
        endpoint={API.tripBookingGuidelines.getAll.url}
        onRowClick={(data, event) =>
          navigateWithEvent(
            Paths.TRIP_BOOKING_GUIDELINE_UPDATE_PAGE.replace(':id', data.id.toString()),
            event
          )
        }
        actions={[
          {
            label: 'Ajouter une nouvelle consigne',
            icon: PlusIcon,
            type: 'global',
            fn: () => navigate(Paths.TRIP_BOOKING_GUIDELINE_CREATE_PAGE)
          }
        ]}
      />
    </div>
  )
}

export default TripBookingGuidelineListPage
